import { put, call, takeLatest, takeEvery, fork, all, select } from "redux-saga/effects";
import { getLocations, getLocationTypes, getMappedFacilityTypes } from "../api/locationApi";
import * as types from "../constants/actionTypes";
import { log, logAPI } from "../api/andyliticsApi";
import * as Google from "../api/googleApi";
import * as portal from "../api/portalApi";
import Cookies from "cookies-js";
import * as Tools from "../helpers/Tools";
const USE_CURRENT_LOCATION = 'Current Location';

export default function* searchLocationsSaga() {
    yield takeLatest(types.SEARCH_LOCATION, handleSearch);
    yield takeLatest(types.GET_LOCATION_TYPES, handleLocationTypes);
    yield takeLatest(types.GET_FACILITY_TYPES, handleFacilityTypes);
    yield takeLatest(types.GEOLOCATION, getGeolocation);
    yield takeLatest(types.GEOADDRESS, getGeolocationAddress);
}

export function* handleSearch(payload) {
    const start = new Date();
    try {
        const locations = yield call(getLocations, payload.searchModel);

        yield all([
            put({ type: types.SEARCH_LOCATION_SUCCESS, locations }),

        ]);

       
        logAPI("MBHWeb.Saga.Location.Get", start, null);

        if (payload.callback) {
            payload.callback(locations);
        }
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Location.Get.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error });
        yield put({ type: types.SEARCH_LOCATION_ERROR });
        if (payload.callback) {
            payload.callback(null);
        }
   }
}

export function* handleLocationTypes(payload) {
    const start = new Date();
    try {
        const locTypes = yield call(getLocationTypes, payload.searchModel);

        yield all([
            put({ type: types.GET_LOCATION_TYPES_SUCCESS, locTypes })
        ]);
        logAPI("MBHWeb.Saga.Location.Get", start, null);
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Location.Get.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error });
    }
}

export function* handleFacilityTypes(payload) {
    const start = new Date();
    try {
        const facTypes = yield call(getMappedFacilityTypes, payload.searchModel);

        yield all([
            put({ type: types.GET_FACILITY_TYPES_SUCCESS, facTypes })
        ]);
        logAPI("MBHWeb.Saga.Location.FacilityTypes.Get", start, null);
    }
    catch (error) {
        console.error(error);
        logAPI("MBHWeb.Saga.Location.FacilityTypes.Get.Failure", start, null, error);
        yield put({ type: types.AJAX_CALL_ERROR, error });
    }
}

export function* getGeolocation(payload) {
    const start = new Date();
    const domain = yield select((state) => state.domain);
    //if usecurrentlocation is true then ask for current location.
    if (payload && payload.useCurrentLocation) {
        try {
            const position = yield call(getCurrentPosition);
            yield put({
                type: types.GEOLOCATION_SUCCESS,
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                isCurrentLocation: true
            });
            logAPI("MBHWeb.Saga.Location.GetCurrentPosition.Success", start, null);
        }
        catch (error) {
             // show geocode error.
            console.log("show geocode error");
            logAPI("MBHWeb.Saga.Location.GetGeoLocation.Failure", start, null, error);
            if (typeof window !== "undefined" && typeof Cookies.get('location_' + domain.un) !== "undefined" && Cookies.get('location_' + domain.un) && Cookies.get('location_' + domain.un) === USE_CURRENT_LOCATION) {
                Cookies.expire('location_' + domain.un, { domain: Tools.getDomain(location.href) });
            }
            yield put({ type: types.GEOLOCATION_FAILURE, geolocationError: getErrorMessage(error), isCurrentLocation: true});
        }
    } else {
         // Fall back to Google Here and check domain reducer if we already have lat and lng.
        if (typeof domain.lt !== 'undefined' && domain.lt !== null && domain.lt !== 0) {
            yield put({
                type: types.GEOLOCATION_SUCCESS,
                latitude: domain.lt,
                longitude: domain.ln,
                isCurrentLocation: false
            });
            return;  // we don't need to re-run the call this session
        } else {
            // Fall back to Google Here
            try {
                const positionGoogle = yield call(Google.getGeoLocation);
                //debugger;
                if (positionGoogle && positionGoogle.location && positionGoogle.location.lat !== null && positionGoogle.location.lat > 0) {
                    yield put({
                        type: types.GEOLOCATION_SUCCESS,
                        latitude: positionGoogle.location.lat,
                        longitude: positionGoogle.location.lng,
                        isCurrentLocation: false
                    }); 
                    yield put({ type: types.GEOADDRESS, location: positionGoogle.location});                    
                    logAPI("MBHWeb.Saga.Location.GetGeoLocation", start, null);
                }
                else {
                    yield put({ type: types.GEOLOCATION_FAILURE, geolocationError: "Geolocation is not enabled on this browser.", isCurrentLocation: false });
                }

            }
            catch (error2) {
                console.error(error2);
                logAPI("MBHWeb.Saga.Location.GetGeoLocation.Failure", start, null, error2);
                yield put({ type: types.GEOLOCATION_FAILURE, geolocationError: getErrorMessage(error2), isCurrentLocation: false });
            }
        }
    }
}

export function* getGeolocationAddress(payload) {    
    const start = new Date();
    const domainData = yield select((state) => state.domain);    
    if (domainData && domainData.t && payload && payload.location && payload.location.lat && payload.location.lng) {
        try {            
            const position = yield call(portal.getAddressFromLatLong, domainData.t, payload.location.lat, payload.location.lng);            
            yield put({
                type: types.GEOADDRESS_SUCCESS,
                city: position.find((element) => element.types[0] ===  "locality").long_name,
                state: position.find((element) => element.types[0] === "administrative_area_level_1").short_name
            });          
            logAPI("MBHWeb.Saga.Location.getGeolocationAddress.Success", start, null);
        }
        catch (error) {            
            // show geocode error.          
            console.log("show geocode error");
            logAPI("MBHWeb.Saga.Location.getGeolocationAddress.Failure", start, null, error);
            yield put({ type: types.GEOADDRESS_FAILURE, geoAddressError: getErrorMessage(error) });
        }
    }
}

function getCurrentPosition() {
    const start = new Date();
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
        logAPI("MBHWeb.Saga.Location.GetCurrentPosition", start, null);
        return new Promise((resolve, reject) =>
            navigator.geolocation.getCurrentPosition(resolve, reject)
        );
    }
    else {
        logAPI("MBHWeb.Saga.Location.GetCurrentPosition.Failure", start, null);
        return new Promise((resolve, reject) =>
            reject({ message: 'Geolocation is not supported.' })
        );
    }
}

function getErrorMessage(error) {      
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return "Geolocation is not enabled on this browser.";
            break;
        case error.POSITION_UNAVAILABLE:
            return "Your location information is not available.";
            break;
        case error.TIMEOUT:
            return "The location request has timed out.";
            break;
        case error.UNKNOWN_ERROR:
            return "We're not able to obtain your location.";
            break;
        default: return "";
    }
}